export default function Topbar() {
  return (
    <section
      className="bg-md-navy text-white/95"
      aria-label="Información de contacto superior"
    >
      <div className="mx-auto max-w-[1280px] px-6 md:px-12">
        <div className="hidden items-center justify-center gap-2 py-2 text-[13px] font-medium md:flex md:gap-6">
          <span className="flex items-center gap-2">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-truck-line" />
            </span>
            Domicilios Pereira y Dosquebradas
          </span>
          <span className="hidden h-4 w-px bg-white/20 md:inline" />
          <a
            href="tel:+573206789030"
            className="flex items-center gap-2 transition-colors hover:text-white"
            onClick={() => {
              if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
                ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
              }
            }}
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-phone-line" />
            </span>
            +57 320 678 9030
          </a>
          <span className="hidden h-4 w-px bg-white/20 md:inline" />
          <span className="flex items-center gap-2">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-time-line" />
            </span>
            Lun–Vie: 8am–12pm, 2pm–5pm
          </span>
        </div>

        <div className="flex flex-col items-center gap-1 py-2 text-[12px] font-medium md:hidden">
          <span className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-truck-line" />
            </span>
            Domicilios Pereira y Dosquebradas
          </span>
          <span className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-phone-line" />
            </span>
            <a
              href="tel:+573206789030"
              className="transition-colors hover:text-white"
              onClick={() => {
                if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
                  ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
                }
              }}
            >
              +57 320 678 9030
            </a>
          </span>
        </div>
      </div>
    </section>
  );
}